import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { MyMapsFilter, PieceSortOrder } from "features/builder/pieceList";

const FILTER_ITEMS: { kind: MyMapsFilter; labelKey: string }[] = [
  { kind: MyMapsFilter.ALL, labelKey: "MSG_BUILDER_FILTER_ALL" },
  { kind: MyMapsFilter.FAVORITE, labelKey: "MSG_BUILDER_FILTER_FAVORITE" },
  { kind: MyMapsFilter.DRAFT, labelKey: "MSG_BUILDER_FILTER_DRAFT" },
  { kind: MyMapsFilter.EDITING, labelKey: "MSG_BUILDER_FILTER_EDITING" },
];

export const MyMapsHeader = ({
  count,
  sortOrder,
  filter,
  onToggleSort,
  onSelectFilter,
}: {
  count: number;
  sortOrder: PieceSortOrder;
  filter: MyMapsFilter;
  onToggleSort: () => void;
  onSelectFilter: (kind: MyMapsFilter) => void;
}) => {
  const play = usePlaySound();

  const handleSelectFilter = (kind: MyMapsFilter) => () => {
    if (kind === filter) return;
    play();
    btnDelay(() => onSelectFilter(kind));
  };

  const handleToggleSort = () => {
    play();
    btnDelay(() => onToggleSort());
  };

  return (
    <div className="flex-row-el items-center justify-between w-full px-2 py-2 shrink-0 gap-2">
      <div className="flex-row-el items-center gap-1 bg-green-100 rounded-full px-3 py-1 shadow-sm shrink-0">
        <span className="material-symbols-outlined text-white type-sm">extension</span>
        <p className="type-text type-sm text-white whitespace-nowrap">
          {I18n.t("MSG_BUILDER_MAP_COUNT", { count })}
        </p>
      </div>

      <div className="flex-row-el items-center gap-2 min-w-0 overflow-x-auto invisible-scrollbar">
        {FILTER_ITEMS.map(({ kind, labelKey }) => {
          const active = kind === filter;
          return (
            <button
              key={kind}
              type="button"
              onClick={handleSelectFilter(kind)}
              className={`type-inherit-font flex-row-center shrink-0 px-3 py-1 rounded-full border-solid border-2 cursor-pointer ${
                active ? "bg-green-100 border-green-100" : "bg-white border-green-100"
              }`}
            >
              <p
                className={`type-text type-sm whitespace-nowrap ${
                  active ? "text-white" : "text-textcolor-black"
                }`}
              >
                {I18n.t(labelKey)}
              </p>
            </button>
          );
        })}
      </div>

      <div className="flex-row-el items-center upsilon shrink-0">
        <button type="button" onClick={handleToggleSort} className="type-inherit-font btn btn-blue">
          <div className="flex-row-center gap-1">
            <span className="material-symbols-outlined text-white type-sm">swap_vert</span>
            <p className="type-text type-sm text-white whitespace-nowrap">
              {I18n.t(
                sortOrder === PieceSortOrder.DESC
                  ? "MSG_BUILDER_SORT_DESC"
                  : "MSG_BUILDER_SORT_ASC",
              )}
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};
